import React from "react";
import { findArray } from 'helpers/utils'
import Pbp from 'components/general/Pbp'
import SportCode from "components/common/SportCode";
import Competitor from "components/presentation/Competitor";
import Noc from 'components/presentation/Noc';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const JudPbp = ({ data }) => {
  const configPpb = {
    sideRender: JudtRenderSide,
    headerRender: () => { },
    disableAccordion: true,
  }
  return (<>
    <Pbp data={data} config={configPpb} />
  </>);
}

const JudtRenderSide = ({ action, homeAway }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters()

  const comp = action?.competitors?.find(item => item?.pbpc_code === homeAway?.participant?.code)
  const athleteCode = comp?.athletes?.find(item => item?.pbpat_order === '1')?.pbpat_code
  const ath = homeAway?.teamAthletes?.find(item => item?.athlete?.code === athleteCode);

  let colour = findArray(homeAway?.teamAthletes?.find(x => x !== undefined)?.eventUnitEntries, { eue_code: ['COLOUR'] })?.eue_value?.toLowerCase();
  if (!comp) return;
  return (
    <>
      <div className={`box uniform-color-${colour} ${colour === 'blue' ? 'text-light' : 'text-end'} d-none d-md-block`}>
        <strong><SportCode discipline={mirs_discipline} entity={action?.pbpa_ActionAdd === 'POINTSTYPE' ? '@PointsType' : '@PenaltyType'} code={action?.pbpa_Action} /></strong>
        &nbsp;-&nbsp;
        <SportCode discipline={mirs_discipline} entity='@Technique' code={action?.pbpa_Result} />
      </div>

      <div className={`box uniform-color-${colour} ${colour === 'blue' ? 'text-light' : ''} d-block d-md-none`}>
        <div className='d-flex justify-content-start'>
          <Noc className='me-1' code={ath?.athlete?.organisation?.code} showImage={true} />
          <Competitor
            noc={homeAway?.participant?.organisation?.code}
            name={ath?.athlete?.name}
            shortName={ath?.athlete?.name}
            code={athleteCode}
            hidePicture={true}
            hideNoc={true} />

        </div>
        <strong><SportCode discipline={mirs_discipline} entity={action?.pbpa_ActionAdd === 'POINTSTYPE' ? '@PointsType' : '@PenaltyType'} code={action?.pbpa_Action} /></strong>
        &nbsp;-&nbsp;
        <SportCode discipline={mirs_discipline} entity='@Technique' code={action?.pbpa_Result} />
      </div>
    </>
  )
}




export default JudPbp;